"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingStatus = exports.equipmentOptions = exports.PurchaseMethod = exports.SubCollection = exports.ExemptionType = exports.Collection = exports.autoRenew = exports.publishAuction = exports.listingType = exports.applicationStatus = exports.newOrUsedEquipment = exports.feedbackTags = exports.productStatus = exports.Status = exports.AccountTypes = exports.adminRole = exports.inspectionStatus = exports.offerStatus = exports.alertTypes = exports.messageTypes = exports.dealStage = exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["DEVELOPMENT"] = "development";
    Environment["PRODUCTION"] = "production";
    Environment["STAGING"] = "staging";
})(Environment || (exports.Environment = Environment = {}));
var dealStage;
(function (dealStage) {
    dealStage["InterestedInBuying"] = "interested in buying";
    dealStage["InspectionCompleted"] = "inspection completed";
    dealStage["InspectionRequested"] = "inspection requested";
    dealStage["NoLongerInterested"] = "no longer interested";
    dealStage["OfferSubmitted"] = "offer submitted";
    dealStage["OfferAccepted"] = "offer accepted";
    dealStage["OfferCountered"] = "offer countered";
    dealStage["OfferDeclined"] = "offer declined";
    dealStage["EquipementPurchased"] = "equipment purchased";
    dealStage["LiensSearched"] = "liens searched";
    dealStage["LiensReleased"] = "liens released";
    dealStage["FundsReceived"] = "funds received";
    dealStage["EquipementPickedUp"] = "equipment picked up";
    dealStage["SellerPaid"] = "seller paid";
    dealStage["LostBid"] = "lost bid";
    dealStage["HoldReceived"] = "hold received";
    dealStage["HoldDeclined"] = "hold declined";
})(dealStage || (exports.dealStage = dealStage = {}));
var messageTypes;
(function (messageTypes) {
    messageTypes["TEXT"] = "text";
    messageTypes["OFFER"] = "offer";
    messageTypes["INSPECTION"] = "inspection";
})(messageTypes || (exports.messageTypes = messageTypes = {}));
var alertTypes;
(function (alertTypes) {
    alertTypes["OfferReceiver"] = "offer receiver";
    alertTypes["OfferSender"] = "offer sender";
    alertTypes["InspectionReceiver"] = "inspection receiver";
    alertTypes["InspectionSender"] = "inspection sender";
    alertTypes["ProductSold"] = "product sold";
    alertTypes["ParticipantLeft"] = "participant left";
    alertTypes["OfferCountered"] = "offer countered";
    alertTypes["CounterofferAccepted"] = "counteroffer accepted";
    alertTypes["CounterofferRejected"] = "counteroffer rejected";
})(alertTypes || (exports.alertTypes = alertTypes = {}));
var offerStatus;
(function (offerStatus) {
    offerStatus["ACCEPTED"] = "accepted";
    offerStatus["REJECTED"] = "rejected";
    offerStatus["COUNTERED"] = "countered";
    offerStatus["WITHDRAWN"] = "withdrawn";
    offerStatus["PENDING"] = "pending";
    offerStatus["EDITIED"] = "edited";
    offerStatus["EXPIRED"] = "expired";
    offerStatus["Sold"] = "sold";
    offerStatus["COUNTER_PENDING"] = "counter pending";
    offerStatus["COUNTER_ACCEPTED"] = "counter offer accepted";
    offerStatus["COUNTER_EDITIED_BUYER"] = "counter offer edited by buyer";
    offerStatus["COUNTER_EDITIED_SELLER"] = "counter offer edited by seller";
    offerStatus["COUNTER_REJECTED"] = "counter offer rejected";
    offerStatus["COUNTER_WITHDRAWN"] = "counter offer withdrawn";
})(offerStatus || (exports.offerStatus = offerStatus = {}));
var inspectionStatus;
(function (inspectionStatus) {
    inspectionStatus["REJECTED"] = "rejected";
    inspectionStatus["PENDING"] = "pending";
    inspectionStatus["DONE"] = "done";
})(inspectionStatus || (exports.inspectionStatus = inspectionStatus = {}));
var adminRole;
(function (adminRole) {
    adminRole["superManager"] = "superManager";
    adminRole["superAdmin"] = "superAdmin";
    adminRole["MSA"] = "MSA";
})(adminRole || (exports.adminRole = adminRole = {}));
var AccountTypes;
(function (AccountTypes) {
    AccountTypes["Customer"] = "Customer";
    AccountTypes["Lender"] = "Lender";
    AccountTypes["Manufacturer"] = "Manufacturer";
    AccountTypes["Other"] = "Other";
    AccountTypes["Services"] = "Services";
    AccountTypes["Transport and Vendor"] = "Transport and Vendor";
})(AccountTypes || (exports.AccountTypes = AccountTypes = {}));
var Status;
(function (Status) {
    Status["Pending"] = "Pending";
    Status["RequestedChanges"] = "RequestedChanges";
    Status["Rejected"] = "Rejected";
    Status["Approved"] = "Approved";
})(Status || (exports.Status = Status = {}));
var productStatus;
(function (productStatus) {
    productStatus["inProgress"] = "inProgress";
    productStatus["Pending"] = "Pending";
    productStatus["Rejected"] = "Rejected";
    productStatus["Approved"] = "Approved";
    productStatus["Sold"] = "Sold";
    productStatus["Canceled"] = "Canceled";
    productStatus["AuctionClosed"] = "AuctionClosed";
})(productStatus || (exports.productStatus = productStatus = {}));
var feedbackTags;
(function (feedbackTags) {
    feedbackTags["Buyer"] = "Buyer";
    feedbackTags["Seller"] = " Seller";
})(feedbackTags || (exports.feedbackTags = feedbackTags = {}));
var newOrUsedEquipment;
(function (newOrUsedEquipment) {
    newOrUsedEquipment["New"] = "New";
    newOrUsedEquipment["Used"] = "Used";
})(newOrUsedEquipment || (exports.newOrUsedEquipment = newOrUsedEquipment = {}));
var applicationStatus;
(function (applicationStatus) {
    applicationStatus["APPLIED"] = "applied";
    applicationStatus["REJECTED"] = "rejected";
    applicationStatus["ACCEPTED"] = "accepted";
})(applicationStatus || (exports.applicationStatus = applicationStatus = {}));
var listingType;
(function (listingType) {
    listingType["BuyNow"] = "Buy Now";
    listingType["Auction"] = "Auction";
})(listingType || (exports.listingType = listingType = {}));
var publishAuction;
(function (publishAuction) {
    publishAuction["NOW"] = "Immediately upon approval";
    publishAuction["LATER"] = "Schedule for later";
})(publishAuction || (exports.publishAuction = publishAuction = {}));
var autoRenew;
(function (autoRenew) {
    autoRenew["ENABLE"] = "Enable";
    autoRenew["DISABLE"] = "Disable";
})(autoRenew || (exports.autoRenew = autoRenew = {}));
var Collection;
(function (Collection) {
    Collection["Accounts"] = "accounts";
    Collection["AchAuthorization"] = "achAuthorization";
    Collection["AdminBankAccountDetails"] = "adminBankAccountDetails";
    Collection["AdminNotifications"] = "adminNotifications";
    Collection["Admins"] = "admins";
    Collection["BuyersPremium"] = "buyersPremium";
    Collection["Categories"] = "categories";
    Collection["Chats"] = "chats";
    Collection["Contacts"] = "contacts";
    Collection["Deals"] = "deals";
    Collection["Feedbacks"] = "feedbacks";
    Collection["Finance"] = "finance";
    Collection["Invoices"] = "invoices";
    Collection["NotificationTemplate"] = "notificationTemplate";
    Collection["Notifications"] = "notifications";
    Collection["Products"] = "products";
    Collection["SalesTax"] = "salesTax";
    Collection["AssetReports"] = "assetReports";
    Collection["TaxExemptionCertificates"] = "taxExemptionCertificates";
    Collection["ZohoSignGeneralMsaAgreement"] = "zohoSignGeneralMsaAgreement";
    Collection["ZohoSignListingAgreement"] = "zohoSignListingAgreement";
    Collection["productViews"] = "productViews";
})(Collection || (exports.Collection = Collection = {}));
var ExemptionType;
(function (ExemptionType) {
    ExemptionType["NonExempt"] = "non_exempt";
    ExemptionType["Wholesale"] = "wholesale";
    ExemptionType["Government"] = "government";
    ExemptionType["Other"] = "other";
})(ExemptionType || (exports.ExemptionType = ExemptionType = {}));
var SubCollection;
(function (SubCollection) {
    SubCollection["AccountAdditionalDetail"] = "accountAdditionalDetails";
    SubCollection["BankAccountInfo"] = "bankAccountInfo";
    SubCollection["Bids"] = "bids";
    SubCollection["Favorites"] = "favorites";
    SubCollection["PersonalDetails"] = "personalDetails";
    SubCollection["PersonalInfo"] = "personalInfo";
    SubCollection["PublicQuestions"] = "publicQuestions";
})(SubCollection || (exports.SubCollection = SubCollection = {}));
var PurchaseMethod;
(function (PurchaseMethod) {
    PurchaseMethod["BuyNow"] = "Buy Now";
    PurchaseMethod["Offer"] = "Offer";
    PurchaseMethod["Bid"] = "Bid";
})(PurchaseMethod || (exports.PurchaseMethod = PurchaseMethod = {}));
var equipmentOptions;
(function (equipmentOptions) {
    equipmentOptions["EquipmentHours"] = "Equipment Hours";
    equipmentOptions["EquipmentMileage"] = "Equipment Mileage";
    equipmentOptions["SerialNumber"] = "Serial Number";
    equipmentOptions["EquipmentVINNumber"] = "Equipment VIN Number";
    equipmentOptions["Unknown"] = "Unknown";
})(equipmentOptions || (exports.equipmentOptions = equipmentOptions = {}));
var listingStatus;
(function (listingStatus) {
    listingStatus["EMAIL_DISPATCHED"] = "E-mail to recipient has beed dispatched";
    listingStatus["RECIPIENT_VIEWED"] = "Recipient Viewed";
    listingStatus["RECIPIENT_SIGNED"] = "Recipient Signed";
    listingStatus["CONSIGNEE_VIEWED"] = "Consignee Viewed";
    listingStatus["CONSIGNEE_SIGNED"] = "Consignee Signed";
    listingStatus["RECIPIENT_DECLINED"] = "Recipient Declines Agreement";
    listingStatus["CONSIGNEE_DECLINED"] = "Consignee Declines Agreement";
    listingStatus["RECIPIENT_FORWADED"] = "Agreement Forwaded to";
})(listingStatus || (exports.listingStatus = listingStatus = {}));
